/*
  Avaliações do Google: botão "Mostrar mais".

  O texto nasce cortado por CSS (-webkit-line-clamp). Aqui só decidimos se o
  botão precisa aparecer: ele só entra em cena quando o texto realmente não
  coube, comparando a altura real com a altura visível.
*/
(() => {
  function ajustar(raiz) {
    (raiz || document).querySelectorAll('[data-gr-texto]').forEach((texto) => {
      const botao = texto.parentElement.querySelector('[data-gr-mais]');
      if (!botao) return;

      texto.dataset.cortado = 'true';
      /* sobra de 2px evita o botão aparecer por arredondamento de fonte */
      const cortou = texto.scrollHeight > texto.clientHeight + 2;
      botao.hidden = !cortou;

      if (!cortou || botao.dataset.pronto === 'true') return;
      botao.dataset.pronto = 'true';
      botao.addEventListener('click', () => {
        const aberto = texto.dataset.cortado !== 'true';
        texto.dataset.cortado = aberto ? 'true' : 'false';
        botao.textContent = aberto ? botao.dataset.textoMais : botao.dataset.textoMenos;
      });
      botao.dataset.textoMais = botao.textContent.trim();
      botao.dataset.textoMenos = 'Mostrar menos';
    });
  }

  function iniciar(raiz) {
    ajustar(raiz);
    /* as fontes assentam depois e mudam a altura do texto */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => ajustar(raiz));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => iniciar(), { once: true });
  } else {
    iniciar();
  }

  let t;
  window.addEventListener('resize', () => {
    clearTimeout(t);
    t = setTimeout(() => ajustar(), 200);
  });

  document.addEventListener('shopify:section:load', (e) => iniciar(e.target));
})();
